import React from 'react'
import { Permission } from 'legacy/common/types'
import { FormattedMessage } from 'react-intl'
import withRetailerRouter from 'legacy/common/withRouter'
import { type RetailerRouteComponentProps } from 'legacy/components/RetailerRoute'
import MetricCollection from 'legacy/components/DataViz/Metrics/MetricCollection'
import { type MetricsData } from 'legacy/components/DataViz/dataViz.types'
import Card from 'legacy/components/Card/Card'
import Link from 'legacy/components/Link'
import AccessControl from 'legacy/components/AccessControl/AccessControl'

interface Props extends RetailerRouteComponentProps {
  metrics: MetricsData[]
  title?: string
  action?: string
}

class MetricsContainer extends React.PureComponent<Props> {
  render() {
    const { metrics, action, title } = this.props
    const hasCardHeader = title || action

    return (
      <Card data-testid="dataviz-metrics-container">
        {hasCardHeader && (
          <Card.Header title={title && <FormattedMessage id={title} />}>
            {action && (
              <Link route={'dashboard'}>
                <FormattedMessage id={action} />
              </Link>
            )}
          </Card.Header>
        )}
        <Card.Body padding="0">
          <MetricCollection metrics={metrics} />
        </Card.Body>
      </Card>
    )
  }
}

export default withRetailerRouter(MetricsContainer)
